(() => {
  if (window.SOPSizeOptionOrder) return;
  window.SOPSizeOptionOrder = true;

  const apparelOrder = [
    'PREEMIE',
    'NEWBORN',
    'NB',
    'XXXXS',
    'XXXS',
    'XXS',
    'XS',
    'S',
    'M',
    'L',
    'XL',
    'XXL',
    'XXXL',
    'XXXXL',
    'ONE SIZE',
    'OS',
    'OSFA',
  ];

  function normalize(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/[–—]/g, '-')
      .replace(/_/g, '-')
      .replace(/\s+/g, ' ');
  }

  function apparelRank(value) {
    const aliases = {
      'EXTRA EXTRA SMALL': 'XXS',
      'EXTRA SMALL': 'XS',
      'X-SMALL': 'XS',
      SMALL: 'S',
      MEDIUM: 'M',
      LARGE: 'L',
      'EXTRA LARGE': 'XL',
      'X-LARGE': 'XL',
      ONESIZE: 'ONE SIZE',
    };
    let normalized = aliases[value] || value;
    const repeatedX = normalized.match(/^(\d+)X([SL])$/);
    if (repeatedX) normalized = `${'X'.repeat(Number(repeatedX[1]))}${repeatedX[2]}`;
    return apparelOrder.indexOf(normalized);
  }

  function sizeKey(value, originalIndex) {
    const normalized = normalize(value);
    const compact = normalized.replace(/\s/g, '');
    const range = compact.match(/^(\d+(?:\.\d+)?)\s*(?:-|TO)\s*(\d+(?:\.\d+)?)(?:MOS?|MONTHS?|M)?$/);

    if (range) return [0, Number(range[1]), Number(range[2]), originalIndex];

    const month = compact.match(/^(\d+(?:\.\d+)?)(?:MOS?|MONTHS?|M)$/);
    if (month) return [0, Number(month[1]), Number(month[1]), originalIndex];

    const apparelParts = normalized.split('/').map((part) => part.trim());
    const apparelRanks = apparelParts.map(apparelRank);
    if (apparelRanks.every((rank) => rank !== -1)) {
      return [1, apparelRanks[0], apparelRanks[apparelRanks.length - 1], originalIndex];
    }

    const numeric = compact.match(/^(\d+(?:\.\d+)?)(?:T|Y|YRS?)?$/);
    if (numeric) return [2, Number(numeric[1]), Number(numeric[1]), originalIndex];

    return [3, 0, 0, originalIndex];
  }

  function compareKeys(a, b) {
    for (let index = 0; index < a.length; index += 1) {
      if (a[index] !== b[index]) return a[index] - b[index];
    }
    return 0;
  }

  function isSizeOptionContainer(container) {
    if (!container || !container.matches) return false;
    if (container.matches('[data-size-option]')) return true;
    if (!container.matches('sticky-variant-radios fieldset[option-name]')) return false;

    return ['SIZE', 'TAILLE', 'GRÖSSE', 'MISURARE'].includes(normalize(container.getAttribute('option-name')));
  }

  function sortRadioGroup(container) {
    const labels = Array.from(container.querySelectorAll(':scope > label[for]'));
    const pairs = Array.from(container.querySelectorAll(':scope > input[type="radio"]')).map((input, index) => ({
      input,
      label:
        labels.find((label) => label.htmlFor === input.id) ||
        (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL' ? input.nextElementSibling : null),
      key: sizeKey(input.value, index),
    }));

    pairs.sort((a, b) => compareKeys(a.key, b.key)).forEach(({ input, label }) => {
      container.append(input);
      if (label) container.append(label);
    });
  }

  function sortDropdown(container) {
    const select = container.querySelector(':scope select');
    if (!select) return;

    Array.from(select.options)
      .map((option, index) => ({ option, key: sizeKey(option.value, index) }))
      .sort((a, b) => compareKeys(a.key, b.key))
      .forEach(({ option }) => select.append(option));
  }

  function sortSizeOptions(root = document) {
    const containers = [];
    const selector = '[data-size-option], sticky-variant-radios fieldset[option-name]';

    if (root.nodeType === Node.ELEMENT_NODE && isSizeOptionContainer(root)) containers.push(root);
    if (root.querySelectorAll) {
      containers.push(...Array.from(root.querySelectorAll(selector)).filter(isSizeOptionContainer));
    }

    containers.forEach((container) => {
      if (container.matches('fieldset')) sortRadioGroup(container);
      else sortDropdown(container);
    });
  }

  sortSizeOptions();
  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach(sortSizeOptions));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
